import Grid from '@material-ui/core/Grid/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { SegmentTypes } from '../../../../../models/itinerary';
import { Icon } from './Icon';

interface OwnProps {
  index?: number;
  recommended?: boolean;
  type: SegmentTypes;
}

interface HeaderProps extends OwnProps, WithStyles<typeof styles> {}

const HeaderBase: FunctionComponent<HeaderProps> = ({
  classes,
  index,
  recommended,
  type,
}) => {
  return (
    <Grid container className={classes.root}>
      <Grid container item spacing={16} alignItems="center">
        <Grid item className={classes.column}>
          <Icon recommended={recommended} type={type} />
        </Grid>
        <Grid item xs className={classes.column}>
          <Typography variant="subheading" lineClamp>
            {recommended ? 'Recommended' : `Alternative ${index}`}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

// styled

const styles = ({ spacing: { unit: spacing } }: Theme) =>
  createStyles({
    column: {
      display: 'flex',
    },
    root: {
      boxSizing: 'border-box',
      height: spacing * 6,
      padding: spacing * 2,
      paddingBottom: spacing,
      paddingTop: spacing,
      width: 'auto',
    },
  });

const enhance = compose<HeaderProps, OwnProps>(
  pure,
  withStyles(styles),
);

export const Header = enhance(HeaderBase);

Header.displayName = 'Header';
